import dayjs from 'dayjs'
import { getNameByPageType } from 'helpers/userData'
import { LocalStorageHelper } from 'helpers/localStorageHelper'
import { PageType } from 'types'

type HistoryItem = {
  type: PageType
  page: number
  time: number
}

const UserHistory = () => {
  const userHistory = LocalStorageHelper.get<HistoryItem[]>('userHistory') || []

  return (
    <div className="dark:border-gray-600 mt-4 pb-4 border-b max-h-72 overflow-y-scroll">
      <ul className="justify-between items-center">
        {userHistory.reverse().map((item, index) => {
          return (
            <li key={index} className="flex justify-between items-center mb-2">
              <span className="flex-center">
                {getNameByPageType(item.type)}, {item.page}. Sayfa
              </span>
              <p className="text-sm">{dayjs(item.time).format('DD MMMM YYYY, HH:mm')}</p>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default UserHistory
